<template>
  <div class="feed-new-items-badge">
    <base-button color="primary"
                 @click="$emit('click')">
      {{ $tc("feed.items.newItem", number) }}
    </base-button>
  </div>
</template>

<script>
  export default {
    props: {
      number: {
        required: true
      }
    }
  }
</script>

<style lang="scss">
  .feed-new-items-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 1;
    top: 70px;
    left: 0;
    right: 0;
    margin: auto;

    & > .base-button {
      width: 150px;
    }
  }
</style>
